import React, { useState } from "react";
import { CastContainer, ErrorTypo, StyledBgImg, StyledButton, StyledContainer, StyledImage, StyledInput, StyledTypo } from "./style";
import logo from '../../assets/logo.svg';
import { subscribeCasting } from "../../services/ApiCallServices";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Cast = () => {

    const navigate = useNavigate()
    const [cast_id, setCast_id] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleInputChange = (event) => {
        setError(null)
        setCast_id(event.target.value);
    };

    const handleClick = async () => {
        setLoading(true)
        try {
            const res = await subscribeCasting(cast_id);
            setLoading(false)
            if (res?.success) {
                navigate(`/${cast_id}`, { state: { cast_id: cast_id, cast_detail: res?.data } });
            } else if (res?.code === 404) {
                setError('Invalid Cast ID');
            }
        } catch (error) {
            console.error('Error in subscribe a casting:', error);
        }
    }

    return (
        <div>
            <StyledContainer>
                <StyledImage src={logo} alt="Logo" />
                <CastContainer>
                    <StyledTypo>Start casting your SENTIO VR tours from your headset</StyledTypo>
                    <div>
                        <StyledInput
                            placeholder="Enter ID"
                            value={cast_id}
                            onChange={handleInputChange}
                        />
                    </div>
                    {error ?
                        <ErrorTypo>{error}</ErrorTypo>
                        : null}
                    <StyledButton onClick={handleClick} disabled={!cast_id}>
                        {loading ? <CircularProgress size={25} sx={{ color: '#FFF' }} /> : 'Start'}
                    </StyledButton>
                </CastContainer>
                <StyledBgImg />
            </StyledContainer>
        </div>
    )
}

export default Cast;







